import baseAPI from "@/http";

const router = "api/MunicipioTemasHabilitados";

export const municipioTemasHabilitadosAPI = {
  salvarTemas: (municipioTemasHabilitados) =>
    baseAPI.post(
      `${router}/adicionar-municipios-temas-habilitados-lote`,
      municipioTemasHabilitados
    ),
  listByMunicipio: (municipioId) =>
    baseAPI.get(
      `${router}/obter-temas-habilitados-por-municipio-id?municipioId=${municipioId}`
    ),
  list: () => baseAPI.get(`${router}`),
};
